<div class="pdf-view-content">

  <!-- ══ LEFT PANEL ══ -->
  <div class="pdf-view-left">

    <div class="pdf-view-header">
      <div>
        <h2 class="pdf-view-title">{{ fileName }}</h2>
       
      </div>
      <div class="pdf-view-actions">
        <p-button [label]="translate?.document.fields.email.singular + ' ' + translate?.document.sections.sec0.singular" icon="fa-regular fa-envelope" styleClass="h-32"
          (onClick)="onEmailFromViewer()">
        </p-button>
        <p-button icon="fa-regular fa-download" styleClass="h-32"
          [pTooltip]=" translate?.general.buttons.download.singular "
          (onClick)="openInNewTab()">
        </p-button>
      </div>
    </div>

    <div class="pdf-preview-container">

      <!-- Remote → iframe -->
      <iframe *ngIf="safeFileUrl"
        [src]="safeFileUrl"
        class="pdf-iframe"
        title="PDF preview">
      </iframe>

      <!-- Local path fallback -->
      <div class="viewer-empty" *ngIf="!safeFileUrl && isLocal(data?.pdfInfo?.fileUrl)">
        <i class="fa-regular fa-file-slash viewer-empty__icon"></i>
        <p><strong>Stored on server filesystem.</strong></p>
        <p class="text-muted mb-2">Browsers cannot preview local paths.</p>
        <div class="local-path">
          <code>{{ data?.pdfInfo?.fileUrl }}</code>
          <button type="button" class="custella-btn-white h-32 ms-2" (click)="copyPath()">{{ translate?.general.buttons.copy.singular }}</button>
        </div>
      </div>

      <!-- No URL -->
      <div class="viewer-empty" *ngIf="!safeFileUrl && !data?.pdfInfo?.fileUrl">
        <i class="fa-regular fa-file-slash viewer-empty__icon"></i>
        <p class="text-muted">No file URL available for this PDF.</p>
      </div>

    </div>
  </div>

  <!-- ══ RIGHT PANEL ══ -->
  <div class="pdf-view-right">

    <!-- Header + close -->
    <div class="pdf-right-header">
      <div>
        <h3 class="pdf-right-title">{{ fileName }}</h3>
      </div>
      <button class="icon-btn" aria-label="Close"
        [pTooltip]="translate?.general.buttons.close.singular"
        (click)="onClose()">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <!-- Document Details -->
    <div class="pdf-details-section">
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{ translate?.document.label.singular }}</span>
        <span class="pdf-detail-value">{{ fileName }}</span>
      </div>
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{ translate?.document.fields.version.singular }}</span>
        <span class="pdf-detail-value">{{ pdfVersion }}</span>
      </div>
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{translate?.setup.modules.templates.fields.templateName.singular}}</span>
        <span class="pdf-detail-value">{{ data?.pdfInfo?.pdfTemplate?.templateName ?? '—' }}</span>
      </div>
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{translate?.jobOrder?.label?.singular}}</span>
       
        <ng-container *ngIf="data?.pdfInfo?.triggerStatus; else noStatus">
            <span class="p-mr-2 p-tag p-component"  [attr.style]="'background-color:' + data?.pdfInfo?.triggerStatus?.colorCode + '50 !important;'">
              <span class="p-tag-value text-dark">{{ data?.pdfInfo?.triggerStatus?.fieldLabel }}</span>
            </span>
        </ng-container>
        <ng-template #noStatus>
          <span class="metric-value">—</span>
        </ng-template>


      </div>
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{ translate?.document.fields.notes.singular }}</span>
        <span class="pdf-detail-value">{{ data?.pdfInfo?.notes ?? '-' }}</span>
      </div>
      
      <div class="pdf-detail-row">
        <span class="pdf-detail-label">{{translate?.general.systemInformation.fields.createdBy.singular}}</span>
        <span class="pdf-detail-value">
        {{ data?.pdfInfo?.createdByUser?.fullName }},
        {{ formatDate(data?.pdfInfo?.createdDate) }}
      </span>
      </div>
    </div>

    <!-- Email Audit Trail -->
    <div class="pdf-audit-header">
      <h3 class="pdf-audit-title">{{translate?.document.fields.email.singular}} Audit Trail</h3>
    </div>

    <div class="pdf-audit-section">

      <!-- Audit cards -->
      <div class="pdf-audit-card" *ngFor="let audit of audits">
        <!-- <div class="pdf-audit-card__icon">
          <i class="fa-regular fa-envelope"></i>
        </div> -->
        <div class="pdf-audit-card__body">
          <!-- Email Address -->
           <div class="flex-between">
              <span class="pdf-audit-card__email">{{ audit.emailAddress }}</span>
              <span class="pdf-audit-card__version">v{{ audit.pdfVersion ?? '—' }}</span>
           </div>
          <!-- CC Email Addresses -->
           <div class="pdf-audit-card__cc-container" *ngIf="audit?.ccAddresses">
              <span class="pdf-audit-card__cc-label">{{ translate?.document.fields.cc.singular }}</span>
              <span class="pdf-audit-card__cc-email">
                {{ audit?.ccAddresses}}
              </span>
           </div>

           <!-- Sent At Date -->
          <span class="pdf-audit-card__time">{{ formatDate(audit.sentAt) }}</span>
        </div>
      </div>

      <!-- Empty state -->
      <div class="pdf-audit-empty" *ngIf="!hasAuditTrail">
        <i class="fa-regular fa-inbox"></i>
        No audit trail available
      </div>

    </div>
  </div>

</div>